import enLang from './entries/en_US';
import frLang from './entries/fr_FR';
import trLang from './entries/tr_TR';
import esLang from './entries/es_ES';
import ptLang from './entries/pt_PT';

const AppLocale = {
  en: enLang,
  fr: frLang,
  tr: trLang,
  es: esLang,
  pt: ptLang,
};

export default AppLocale;
